import { render, staticRenderFns } from "./shareMod.vue?vue&type=template&id=d5d4bfdc&scoped=true&"
import script from "./shareMod.vue?vue&type=script&lang=ts&"
export * from "./shareMod.vue?vue&type=script&lang=ts&"
import style0 from "./shareMod.vue?vue&type=style&index=0&id=d5d4bfdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d4bfdc",
  null
  
)

export default component.exports